<template>
  <div >
    <div class="glitchHolder">
      <div v-if="glitches" id="glitchOverlay" :style="{top:glitchTop+'px'}">
        <div
          v-for="g in glitches" :key="'g'+g"
          class="glitchOver"
          :style="{marginBottom:g.pad+'px',width:g.width+'%'}"
        >
          <div
            v-for="gc in g.child" :key="'gc'+gc"
            class="glitchChild"
            :style="{backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'}"
          ></div>
        </div>
      </div>
    </div>

    <div style="width:80%;margin:auto;">
      <div v-for="(ce,i) in currentEvents" :key="'ce'+i"   >  
          <div v-if="showEvent(ce.title)">  
         <div  class="EventHeading" style="font-weight: 600;"><i>{{ce.status}}</i></div>
        <img v-if="ce.image"
          :src="ce.image"
          width="100%"
          
        >
      
        <div class="EventHeading">
          <i>{{ce.title}}</i>
         
        </div>

        <h2>
          {{ce.date}}
          <br />{{ce.location}}
          <br />{{ce.time}}
          <br/>
        </h2>
        <div v-html="ce.content"></div>
       <div><br></div>
        <hr>
         <div><br></div>
        </div>
         </div>
       <h2>Host your Event</h2>
          <p>
            The Loop has the capacity to host screenings with invited audiences, such as for the
            premiere of a neew film or digital art work.
          </p>
          <p>It is also an ideal venue for hybrid and/or interactive art screenings and performances.</p>

          <p>
            Get in touch
            <v-btn to="/contact" pl-0>Contact</v-btn>to discuss your proposal.
          </p>
           </div>
          
    </div>
  
</template>

<script>
// https://wordtohtml.net/ to convert text to html
export default {
  data() {
    return {
      glitches: null,
      glitchCount: 20,
      glitchTop: 0
    };
  },
  mounted() {
     
     
     
    this.$store.dispatch("loadEventsStatus")
    this.glitches = [];
    let childA = [];
    for (var i = 0; i < 8; i++) {
      childA = [];
      for (var p = 0; p < 2; p++) {
        childA.push(Math.floor(Math.random() * 100));
      }
      this.glitches.push({
        colour: "#00000044",
        height: 30,
        pad: 3,
        width: Math.random() * 50 + 50,
        child: childA
      });
    }
    setTimeout(this.glitch, 100);
  },
  computed: {
      

       currentEvent(){
       return this.$store.getters.getCurrentEvent
     },
     currentEvents(){
       return this.$store.getters.getCurrentEvents
     },
    loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
      qstring(){
          return  window.location.search.substr(1);
      },
      showEvent(title){
          if(this.qstring()){
              return this.qstring()== escape(title)
          }else{
              return true
          }
      },
    glitch() {
      this.glitchCount++;
      if (this.glitchCount > 50) {
        this.glitchCount = Math.random() * 20 - 10;
        this.glitchTop = Math.random() * 400 + 100;
      }
      if (this.glitchCount > 10) {
        this.glitchCount += Math.random() * 40;
        setTimeout(this.glitch, Math.random() * 100 + 100);

        return;
      }

      for (var g in this.glitches) {
        if (Math.random() * 10 > 7) {
          this.glitches[g].height = Math.random() * 20 + 5;
          for (var gc in this.glitches[g].child) {
            this.glitches[g].child[gc] = Math.floor(Math.random() * 160 + 20);
          }
          if (Math.random() * 10 > 5) {
            this.glitches[g].height = 0;
          }
        }
        this.glitches[g].pad = Math.floor(Math.random() * 5 + 5);
        this.glitches[g].width = Math.floor(Math.random() * 160 + 20);
      }
      if (Math.random() * 10 > 5) {
        // this.glitchTop=Math.random()*400+100;
      }
      setTimeout(this.glitch, 100);
    }
  }
};
</script>

<style scoped>
.glitchHolder {
  position: absolute;
  top: 0px;
  height: 100%;
  width: 100%;
  min-height: 100px;
  overflow: hidden;
  pointer-events: none;
}
#glitchOverlay {
  position: absolute;
  left: -100px;
  top: 0px;
}
.glitchOver {
  z-index: 3;
  position: relative;
  min-height: 30px;
  pointer-events: none;
  opacity: 0.3;
  width: 400px;
}
.glitchChild {
  width: 40px;
  display: inline-block;
  background-color: #00f;
}

.lhColumn {
  position: relative;
  width: 50%;
}
.rhColumn {
  
  position: relative;
  width: 50%;
  padding: 10px;
}
.EventHeading {
    font-family: Roboto, Helvetica, Arial, sans-serif;
  font-size: 24px;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/Events.vue